<template>
  <v-card class="card pa-4 " color="gray10" flat>
    <div class="d-flex title">
      <v-icon>$editList</v-icon>
      <h2 class="font-Light-16 ms-2 ">مدیریت حساب حقوقی</h2>
    </div>

    <p class="font-Light-16 gray2--text my-6">
      در این قسمت میتوانید لیست صاحبان امضای حساب حقوقی را مشاهده کنید.
    </p>

    <v-card
      class="card d-flex items-center justify-space-between pa-4 mt-3"
      color="gray8"
      flat
    >
      <span class="font-Regular-16">{{ data.name }}</span>
      <div class="">
        <span class="font-Light-14 gray2--text">
          {{ $t("corporateAccount.companyInformation.annualBookDate") }}
          {{ data.registration_date | formatDate }}
        </span>
        <v-icon class="ms-4" clr="var(--v-primary-base)">
          $checkMarkCircleWallet
        </v-icon>
      </div>
    </v-card>

    <div class="mt-4">
      <MemberList :members="members" bg="gray8" />
    </div>

    <!--    <div class="text-center">-->
    <!--      <v-btn x-large color="primary" class="mt-16 px-16" disabled>-->
    <!--        ورود به حساب حقوقی-->
    <!--      </v-btn>-->
    <!--    </div>-->

    <v-dialog v-model="shareRegisterDialog" max-width="600">
      <v-card
        class="d-flex flex-column align-center justify-center pa-4 px-md-8 py-md-16 gray10"
      >
        <div class="pa-1 infoTransparent rounded-pill">
          <v-icon size="68" clr="var(--v-info-base)">$share</v-icon>
        </div>

        <span class="font-Bold-20 mt-6">ایجاد حساب کاربری</span>
        <p class=" font-Regular-17 gray2--text mt-6">
          آیا مطمئن هستید می‌خواهید این مجوز را لغو کنید؟
        </p>

        <div
          class="d-flex flex-column flex-md-row align-center justify-space-between gray8 rounded-lg w-100 pa-2 mt-8"
        >
          <div class="d-flex flex-column flex-md-row align-center">
            <div class="pa-1 infoTransparent rounded-pill">
              <v-icon size="30">$link</v-icon>
            </div>
            <div class="d-flex flex-column ms-md-2 my-4 my-md-0 text-center">
              <span class="font-Regular-14">کپی آدرس ثبت نام در اکسکوینو</span>
              <span class="font-Light-13 mt-2 gray2--text">
                شما میتوانید لینک ثبت نام را برای سایر اعضا ارسال کنید
              </span>
            </div>
          </div>
          <v-btn color="primary"> کپی کردن</v-btn>
        </div>

        <div
          class="d-flex flex-wrap align-center justify-center gray8 rounded-lg w-100 pa-2 mt-8"
        >
          <a href="#" class="d-flex flex-column align-center ma-3">
            <img src="../../assets/image/telegram.svg" alt="" />
            <span class="mt-3 gray2--text">تلگرام</span>
          </a>
          <a href="#" class="d-flex flex-column align-center ma-3">
            <img src="../../assets/image/x.svg" alt="" />
            <span class="mt-3 gray2--text">ایکس</span>
          </a>
          <a href="#" class="d-flex flex-column align-center ma-3">
            <img src="../../assets/image/instagram.svg" alt="" />
            <span class="mt-3 gray2--text">اینستاگرام</span>
          </a>
          <a href="#" class="d-flex flex-column align-center ma-3">
            <img src="../../assets/image/whatsapp.svg" alt="" />
            <span class="mt-3 gray2--text">واتس اپ</span>
          </a>
        </div>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import MemberList from "@/components/Shared/LegalEntity/MemberList.vue";
import legalService from "@/services/modules/legalService";
export default {
  components: { MemberList },
  props: ["members"],
  data() {
    return {
      shareRegisterDialog: false,
      data: null
    };
  },
  mounted() {
    legalService
      .accountDetailsWithMember(this.$route.query.CA_ID)
      .then(response => {
        this.data = response.data.data;
      });
  }
};
</script>

<style scoped lang="scss">
.company {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  border: 1px solid var(--v-primary-base);
  border-radius: 0.5rem;
}
</style>
